module.exports = __webpack_public_path__ + "img/workContents03_pc_02.083e98ee.png";